const accountIdsToBeBlacklisted = [
    87961397, 89065536, 54301128, 53317717, 87179189, 64550601, 52385050, 54066167, 86514607,
    91140830, 62695255, 86391919, 70689066, 87774931, 60308083, 91448296, 77224100, 79868874,
    54513404, 89075315, 55270173, 54304529, 69777147, 53797291, 51628342, 53786730, 54085933,
    80039308, 86939429, 86939444, 88924248, 89853861, 93017364,
];

export default accountIdsToBeBlacklisted;
